/*eslint-disable */
var $ = window.jQuery = require('jquery');
import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  //  const router {
  mode: 'history',
  canReuse: false,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [{
      path: '*',
      redirectTo: '/'
    },
    {
      path: '/',
      name: 'login',
      component: () => import( /* webpackChunkName: "Login" */ './view/login/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap'
        next();
      }
    },
    {
      path: '/dashboard/',
      component: () => import( /* webpackChunkName: "Dashboard" */ './view/dashboard/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getAcUserDetailsFun')
        next();
      },
      children: [
        {
          path: '/',
          redirect: {
            name: 'DashboardMain'
          }
        },
        {
          path: '/home/',
          name: 'DashboardMain',
          component: () => import( /* webpackChunkName: "Dashboard" */ './view/home-dashboard/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getNuAcUpdatesListFun')
            document.title = 'Lymphomap - Home'
            next();
          }
        },
        {
          path: '/task/old/',
          name: 'Dashboard',
          component: () => import( /* webpackChunkName: "Dashboard" */ './view/lymphomap/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getInputAttrListFun')
            document.title = 'Lymphomap - Home'
            next();
          }
        },
        {
          path: '/task/',
          name: 'Task',
          component: () => import( /* webpackChunkName: "Task" */ './view/task-new-page/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            // store.dispatch('getInputAttrListFun')
            document.title = 'Lymphomap - Task New'
            next();
          }
        },
        {
          path: '/profile/update/',
          name: 'profileUpdate',
          component: () => import( /* webpackChunkName: "profileUpdate" */ './view/profile-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - Profile Update'
            next();
          }
        },
        {
          path: '/data-well/',
          name: 'dataWell',
          component: () => import( /* webpackChunkName: "datawell" */ './view/data-well/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getAcUserDetailsFun')
            store.dispatch('getDataWellFun')
            document.title = 'Lymphomap - Data Well'
            next();
          }
        },
        {
          path: '/su/organization/',
          name: 'organizationList',
          component: () => import( /* webpackChunkName: "organizationList" */ './view/organizations-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgListFun')
            document.title = 'Lymphomap - User'
            next();
          }
        },
        {
          path: '/su/organization/:orgId/details/',
          name: 'organizationDetails',
          component: () => import( /* webpackChunkName: "organizationDetails" */ './view/organizations-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgDetailsByIdFun', {id:to.params.orgId})
            document.title = 'Lymphomap - Organization Details'
            next();
          }
        },
        {
          path: '/su/organization/:orgId/make/super/admin/',
          name: 'makeSuperAdmin',
          component: () => import( /* webpackChunkName: "makeSuperAdmin" */ './view/make-super-admin/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Change Admin'
            next();
          }
        },
        {
          path: '/su/organization/:orgId/details/update/',
          name: 'organizationDetailsUpdate',
          component: () => import( /* webpackChunkName: "organizationDetailsUpdate" */ './components/organization-details-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgDetailsByIdFun', {id:to.params.orgId})
            document.title = 'Lymphomap - Organization Details Update'
            next();
          }
        },
        {
          path: '/su/organization/add/',
          name: 'organizationAdd',
          component: () => import( /* webpackChunkName: "organizationAdd" */ './components/organization-create/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Organization Add'
            next();
          }
        },
        {
          path: '/su/organization/:orgUserId/user/add/',
          name: 'organizationUserAdd',
          component: () => import( /* webpackChunkName: "organizationUserAdd" */ './components/organization-user-create/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Organization User Add'
            next();
          }
        },
        {
          path: '/su/organization/:userId/user/update/',
          name: 'organizationUserUpdate',
          component: () => import( /* webpackChunkName: "organizationUserUpdate" */ './components/organization-user-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgUseDetailsByIdFun', {id:to.params.userId})
            document.title = 'Lymphomap - Organization User Update'
            next();
          }
        },
        {
          path: '/su/organization/user/:userDetailsId/details/',
          name: 'organizationUserDetails',
          component: () => import( /* webpackChunkName: "organizationUserDetails" */ './view/organization-user-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgUserDetailsByIdFun', {id:to.params.userDetailsId})
            store.dispatch('getUserTaskListFun', {id:to.params.userDetailsId})
            document.title = 'Lymphomap - Organization User Details'
            next();
          }
        },
        {
          path: '/su/organization/connection/request/list/:orgReqId/',
          name: 'organizationConnectionRequestList',
          component: () => import( /* webpackChunkName: "organizationConnectionRequestList" */ './view/organization-connection-request-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('orgConnectionReqListFun', {id:to.params.orgReqId})
            document.title = 'Lymphomap - Organization Connection List'
            next();
          }
        },
        {
          path: '/su/organization/user/request/list/:userReqId/',
          name: 'organizationUserRequestList',
          component: () => import( /* webpackChunkName: "organizationUserRequestList" */ './view/user-connection-request-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('userChatRequestListFun', {id:to.params.userReqId})
            document.title = 'Lymphomap - Organization User Request List'
            next();
          }
        },
        {
          path: '/su/account/updates/list/',
          name: 'acSuUpdatesList',
          component: () => import( /* webpackChunkName: "acSuUpdatesList" */ './view/su-account-updates/account-su-updates-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSuAcUpdatesListFun')
            document.title = 'Lymphomap - Account Update List'
            next();
          }
        },
        {
          path: '/su/account/updates/create/',
          name: 'acSuUpdatesCreate',
          component: () => import( /* webpackChunkName: "acSuUpdatesCreate" */ './view/su-account-updates/account-su-updates-create/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Account Update Create'
            next();
          }
        },
        {
          path: '/su/account/updates/:updatesId/update/',
          name: 'acSuUpdatesUpdate',
          component: () => import( /* webpackChunkName: "acSuUpdatesUpdate" */ './view/su-account-updates/account-su-updates-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSuAcUpdatesListByIdFun', {id:to.params.updatesId})
            document.title = 'Lymphomap - Account Update Create'
            next();
          }
        },
        {
          path: '/sa/organization/',
          name: 'saOrganizationList',
          component: () => import( /* webpackChunkName: "saOrganizationList" */ './view/super-admin/sa-organization-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSaOrgListFun')
            document.title = 'Lymphomap - Admin'
            next();
          }
        },
        {
          path: '/sa/organization/update/',
          name: 'saOrganizationUpdate',
          component: () => import( /* webpackChunkName: "saOrganizationUpdate" */ './view/super-admin/sa-organization-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSaOrgListFun')
            document.title = 'Lymphomap - Organization Update'
            next();
          }
        },
        {
          path: '/sa/organization/user/create/',
          name: 'saOrganizationUserCreate',
          component: () => import( /* webpackChunkName: "saOrganizationUserCreate" */ './view/super-admin/sa-organization-user-create/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Organization User Create'
            next();
          }
        },
        {
          path: '/sa/organization/user/:saUserId/update/',
          name: 'saOrganizationUserUpdate',
          component: () => import( /* webpackChunkName: "saOrganizationUserUpdate" */ './view/super-admin/sa-organization-user-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSaOrgUseDetailsByIdFun', {id:to.params.saUserId})
            document.title = 'Lymphomap - Organization User Update'
            next();
          }
        },
        {
          path: '/sa/organization/user/:saUserDetailsId/details/',
          name: 'saOrganizationUserDetails',
          component: () => import( /* webpackChunkName: "saOrganizationUserDetails" */ './view/super-admin/sa-organization-user-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSaOrgUseDetailsByIdFun', {id:to.params.saUserDetailsId})
            store.dispatch('getSaUserTaskListFun', {id:to.params.saUserDetailsId})
            document.title = 'Lymphomap - Organization User Details'
            next();
          }
        },
        {
          path: '/support/chat/',
          name: 'userChatList',
          component: () => import( /* webpackChunkName: "userChatList" */ './view/chat-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('adminChatListFun')
            // store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - Super User Chat List'
            next();
          }
        },
        {
          path: '/chat/',
          name: 'normalUserChatList',
          component: () => import( /* webpackChunkName: "normalUserChatList" */ './view/chat-normal-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            // store.dispatch('normalUserChatListFun')
            store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - User Chat List'
            next();
          }
        },
        {
          path: '/chat/user/block/list/',
          name: 'userBlockList',
          component: () => import( /* webpackChunkName: "userBlockList" */ './components/blocked-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getBlockUserFun')
            document.title = 'Lymphomap - User Block List'
            next();
          }
        },
        {
          path: '/organization/',
          name: 'normalOrganizationList',
          component: () => import( /* webpackChunkName: "normalOrganizationList" */ './view/noraml-user-org-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('normalUserOrgListFun')
            store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - Organization'
            next();
          }
        },
        {
          path: '/organization/:OrgByUserId/user/list/',
          name: 'OrganizationByUserList',
          component: () => import( /* webpackChunkName: "OrganizationByUserList" */ './view/user-list-by-organization/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getUserListByOrgFun', {id:to.params.OrgByUserId})
            store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - Organization User List'
            next();
          }
        },
        {
          path: '/member/users/',
          name: 'membersAllUsers',
          component: () => import( /* webpackChunkName: "membersAllUsers" */ './view/member-all-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('memberAllUsersListFun')
            document.title = 'Lymphomap - Member Users'
            next();
          }
        },
        {
          path: '/video/conference/',
          name: 'videoCreateMeeting',
          component: () => import( /* webpackChunkName: "create-meeting" */ './view/video-meeting-create/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - Video Conference',
            next();
          }
        },
        {
          path: '/video/room/',
          name: 'videoChat',
          component: () => import( /* webpackChunkName: "chat-room" */ './view/video-conference-chat/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            // console.log(to.hash, "Check Hash")
            store.dispatch('checkRoomValidIdFun',{room_id:to.hash}).then((res)=>{
              store.dispatch('getAcUserDetailsFun')
              next();
            }).catch((err)=>{
              router.push('/video/conference/')
            })
            // store.dispatch('getAcUserDetailsFun')
            // next();
            document.title = 'Lymphomap - Video Conference'
          }
        },
        {
          path: '/video/user/left/room/',
          name: 'UserLeftRoom',
          component: () => import( /* webpackChunkName: "UserLeftRoom" */ './view/user-left-room/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Video User Left Room',
            next();
          }
        },
        {
          path: '/member/users/details/:userDetailsId/',
          name: 'memberUserDetails',
          component: () => import( /* webpackChunkName: "memberUserDetails" */ './view/user-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getMemberUserDetailsFun',{id:to.params.userDetailsId})
            store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - User Details'
            next();
          }
        },
        {
          path: '/request/list/',
          name: 'saChatRequestList',
          component: () => import( /* webpackChunkName: "saChatRequestList" */ './view/super-admin/chat-request-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('chatConnectionRequestListFun')
            document.title = 'Lymphomap - User Request'
            next();
          }
        },
        {
          path: '/user/',
          name: 'usersList',
          component: () => import( /* webpackChunkName: "usersList" */ './view/users/all-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getAllUserListsFun')
            store.dispatch('getDeactivatedAllUserListsFun')
            store.dispatch('getListOfSignupedUserFun')
            document.title = 'Lymphomap - Users'
            next();
          }
        },
        {
          path: '/user/add/',
          name: 'addUser',
          component: () => import( /* webpackChunkName: "addUser" */ './view/users/user-add/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - User Add'
            next();
          }
        },
        {
          path: '/user/:updateUserID/update/',
          name: 'updateUser',
          component: () => import( /* webpackChunkName: "updateUser" */ './view/users/user-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgUseDetailsByIdFun', {id:to.params.updateUserID})
            document.title = 'Lymphomap - User Update'
            next();
          }
        },
        {
          path: '/user/:UserID/connection/list/',
          name: 'userConnectionList',
          component: () => import( /* webpackChunkName: "userConnectionList" */ './view/users/user-connection-request-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('userChatRequestListFun', {id:to.params.UserID})
            document.title = 'Lymphomap - User Connection'
            next();
          }
        },
        {
          path: '/user/:UserID/activity/details/',
          name: 'userActivityDetails',
          component: () => import( /* webpackChunkName: "userActivityDetails" */ './view/users/user-activity-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getUserTaskListFun', {id:to.params.UserID})
            document.title = 'Lymphomap - User Activity Details'
            next();
          }
        },
        {
          path: '/video/room/one-to-one-peer/',
          name: 'videoChatOneToOnePeer',
          component: () => import( /* webpackChunkName: "videoChatOneToOnePeer" */ './view/direct-video-conference-chat/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('checkRoomValidIdFun',{room_id:to.hash}).then((res)=>{
              store.dispatch('getAcUserDetailsFun')
              next();
            }).catch((err)=>{
              router.push('/video/conference/')
            })
            document.title = 'Lymphomap - Video Conference'
          }
        },
        {
          path: '/video/one-to-one-peer/left/room/',
          name: 'OneToOnePeerLeftRoom',
          component: () => import( /* webpackChunkName: "OneToOnePeerLeftRoom" */ './view/direct-call-from-user-left/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Video User Left Room',
            next();
          }
        },
      ]
    },
  ]
})

// Routes use for without login. these are the name of routes not path
const openRoutes = ['login']

// Routes use for without login
router.beforeEach((to, from, next) => {
  if (openRoutes.includes(to.name)) {
    next();
  } else if (store.getters.isAuthenticated && localStorage.getItem('token') != '' && localStorage.getItem('token') != null && localStorage.getItem('LoginedUserID') != '' && localStorage.getItem('LoginedUserID') != null) {
    next()
  } else {
    let redirectTo = to.path;
    let redirectToHash = to.hash;
    let redirectToFull = '?redirect=' + redirectTo + redirectToHash;
    next('/' + redirectToFull)
    console.log(redirectToFull, "Redircte path checking")
  }
})

/** Show loader when moving routes */
router.beforeResolve((to, from, next) => {
	if (to.name) {
		if (openRoutes.includes(to.name)) {
			$(".preloader").show()
		}
		next();
	}
});

/** Hide preloader after each routes */
router.afterEach((to, from) => {
	if (openRoutes.includes(to.name)) {
		$(".preloader").delay(200).fadeOut("slow");
	}
});

export default router;
